<template>
  <div :class="classObj" class="app-wrapper">
    <!-- <div class="drawer-bg" @click="handleClickOutside" /> -->
    <sidebar class="sidebar-container"></sidebar>
    <div class="main-container">
      <navbar />
      <appmain />
    </div>
  </div>
</template>

<script>
import { Navbar, Sidebar, Appmain } from "./components";
import { mapState } from "vuex";

// import Cookies from "js-cookie";
export default {
  name: "Layout",
  components: {
    Navbar,
    Sidebar,
    Appmain
  },
  computed: {
    ...mapState({
      sidebar: state => state.sidebar
    }),
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation
      };
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/mixin.scss";
@import "~@/styles/variables.scss";

.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;

  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
}

// .drawer-bg {
//   background: #000;
//   opacity: 0.3;
//   width: 100%;
//   top: 0;
//   height: 100%;
//   position: absolute;
//   z-index: 999;
// }

.fixed-header {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9;
  width: calc(100% - #{$sideBarWidth});
  transition: width 0.28s;
}

.hideSidebar .fixed-header {
  width: calc(100% - 54px);
}

.mobile .fixed-header {
  width: 100%;
}
</style>
